module.exports = __webpack_public_path__ + "img/thumbs-up.d0848e60.png";